'use client';

import {
  createContext,
  type PropsWithChildren,
  useContext,
  useRef,
} from 'react';
import { useStore } from 'zustand';
import { type CartStore, createCartStore, initCartStore } from './cart-store';

export type CartStoreApi = ReturnType<typeof createCartStore>;

export const CartStoreContext = createContext<CartStoreApi | undefined>(
  undefined
);

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export type CartStoreProviderProps = PropsWithChildren;

export const CartStoreProvider = ({ children }: CartStoreProviderProps) => {
  const storeRef = useRef<CartStoreApi>(undefined);
  if (!storeRef.current) {
    storeRef.current = createCartStore(initCartStore());
  }

  return (
    <CartStoreContext.Provider value={storeRef.current}>
      {children}
    </CartStoreContext.Provider>
  );
};

export const useCartStore = <T,>(selector: (store: CartStore) => T): T => {
  const cartStoreContext = useContext(CartStoreContext);

  if (!cartStoreContext) {
    throw new Error(`useCartStore must be used within CartStoreProvider`);
  }

  return useStore(cartStoreContext, selector);
};
